import { render, staticRenderFns } from "./KvkSuggestionsTable.vue?vue&type=template&id=7536a366&"
import script from "./KvkSuggestionsTable.vue?vue&type=script&lang=js&"
export * from "./KvkSuggestionsTable.vue?vue&type=script&lang=js&"
import style0 from "./KvkSuggestionsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports